export interface ISuggestedPrompt {
  label: string;
  prompt: string;
}

export interface ISuggestedPromptContext {
  jobId?: number | null;
}

const BASE_PROMPTS: ISuggestedPrompt[] = [
  {
    label: 'My hours this week',
    prompt: 'How many hours have I logged this week?',
  },
  {
    label: 'Open service work orders',
    prompt: 'Which service work orders are still open?',
  },
  {
    label: 'Job cost summary',
    prompt: 'Give me a cost summary across my active jobs.',
  },
];

const JOB_PROMPT: ISuggestedPrompt = {
  label: "This job's cost summary",
  prompt: 'Give me a cost summary for the currently selected job.',
};

/** @registry Returns the 3-4 F.I.R.E. starter prompts to show in the empty chat state; prepends a job-specific prompt when a job is selected. */
export const getSuggestedPrompts = (
  context: ISuggestedPromptContext,
): ISuggestedPrompt[] => {
  if (context.jobId != null) {
    return [JOB_PROMPT, ...BASE_PROMPTS];
  }
  return BASE_PROMPTS;
};
